const SET_ACTIVE_TAB = 'SET_ACTIVE_TAB'
const SET_EQUIPMENT = 'SET_EQUIPMENT'
const SET_ERROR_CODE = 'SET_ERROR_CODE'
const SET_CATALOGUE_SELECTIONS = 'SET_CATALOGUE_SELECTIONS'

export {
  SET_ACTIVE_TAB,
  SET_EQUIPMENT,
  SET_ERROR_CODE,
  SET_CATALOGUE_SELECTIONS,
}
